import React, { useState } from "react";
import { Typography, message } from "antd";
import { useTranslation } from "react-i18next";
import GET_LANGUAGES from "graphql/queries/GetLanguages";
import GET_MY_SETTINGS from "graphql/queries/GetMySettings";
import UPDATE_PROFILE from "graphql/mutations/UpdateProfile";
import { useQuery, useMutation } from "@apollo/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

import { Language } from "types";
import LanguageLevelForm from "./LanguageLevelForm";
// Styling
import {
  CustomButton,
  CustomCard,
  CardTitle,
  StyledContent,
} from "./AfterSignUpStyle";

interface TProps {
  setStep: React.Dispatch<React.SetStateAction<number>>;
}

const AfterRegistrationStep3 = (props: TProps) => {
  const { setStep } = props;
  const [showLanguageLevelForm, setShowLanguageLevelForm] = useState(false);

  const { t } = useTranslation("after_sign_up");
  const { data: languageList } = useQuery(GET_LANGUAGES);
  const { data } = useQuery(GET_MY_SETTINGS, {
    fetchPolicy: "network-only",
  });
  const studyLanguage = languageList?.languages.find((language: Language) => {
    return language.id === data?.me.currentLanguage.id;
  });
  const [updateMyLanguageLevel] = useMutation(UPDATE_PROFILE);

  const handleOnClickNo = async () => {
    try {
      await updateMyLanguageLevel({
        variables: {
          input: {
            attributes: {
              currentLanguageId: studyLanguage?.id,
              currentLevelId: studyLanguage?.levels[0].id,
            },
          },
        },
      });
    } catch (e) {
      message.error(t("Failed saving changes. Please try again."));
    } finally {
      message.success(
        t(
          `Your level was set as ${studyLanguage?.levels[0].title}. You can change it in "My Settings" `
        )
      );
      setStep(3);
    }
  };
  const handleOnClickYes = () => {
    setShowLanguageLevelForm(true);
  };

  const handleOnClickPrev = () => setStep(1);
  return (
    <StyledContent className="content-container confirm-registration-container">
      {!showLanguageLevelForm ? (
        <CustomCard className="step3 page1">
          <CardTitle>
            <button
              type="button"
              className="icon-btn"
              onClick={handleOnClickPrev}
            >
              <FontAwesomeIcon
                icon={faArrowLeft as IconProp}
                className="icon"
                size="2x"
              />
            </button>
            {t("Select Your Level").toUpperCase()}
          </CardTitle>
          <CustomCard className="content">
            <Typography.Title level={5}>
              {t("Have you studied ")}
              {studyLanguage?.englishName}
              {t(" before?")}
            </Typography.Title>
            <CustomButton className="toggle-btn full" onClick={handleOnClickNo}>
              {t("No, I have not").toUpperCase()}
            </CustomButton>
            <CustomButton
              className="toggle-btn full"
              onClick={handleOnClickYes}
            >
              {t("Yes, I have").toUpperCase()}
            </CustomButton>
          </CustomCard>
        </CustomCard>
      ) : (
        <LanguageLevelForm
          setShowLanguageLevelForm={setShowLanguageLevelForm}
          setStep={setStep}
        />
      )}
    </StyledContent>
  );
};

export default AfterRegistrationStep3;
